import type { FigmaIconProps } from './types';

export const IconFigmaClockS = ({ size = 11, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={11.2666}
    viewBox="0 0 11 11.2666"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16602 5.88281C9.16584 3.79348 7.47218 2.09961 5.38281 2.09961C3.29359 2.09979 1.59979 3.79359 1.59961 5.88281C1.59961 7.97218 3.29348 9.66584 5.38281 9.66602C7.47229 9.66602 9.16602 7.97229 9.16602 5.88281ZM10.7666 5.88281C10.7666 8.85595 8.35595 11.2666 5.38281 11.2666C2.40983 11.2664 0 8.85584 0 5.88281C0.000176005 2.90994 2.40994 0.500176 5.38281 0.5C8.35584 0.5 10.7664 2.90983 10.7666 5.88281Z"
      fill={color}
    />
    <path
      d="M4.58333 3.13314C4.58333 2.69131 4.94131 2.33333 5.38314 2.33333C5.82497 2.33333 6.18294 2.69131 6.18294 3.13314V5.38802L7.57454 6.08431C7.96954 6.28198 8.12951 6.76246 7.93197 7.15755C7.73437 7.55274 7.25391 7.71257 6.85872 7.51497L5.02572 6.59896C4.75469 6.46344 4.58333 6.18616 4.58333 5.88314V3.13314Z"
      fill={color}
    />
  </svg>
);
